import { useQuery } from '@tanstack/react-query';
import { fetchCmrBuildingPartCodebook,
  fetchCmrSpecialBuildingPartCodebook,
  fetchCmrSpaceTypeCodebook, fetchCmrFloorCodebook, fetchCmrFloorTypeCodebook, fetchCmrRoomCountCodebook, fetchCmrLivingRoomCountCodebook, fetchCmrKitchenCountCodebook, fetchCmrBathroomCountCodebook, fetchCmrSeparateToiletCountCodebook, fetchCmrDisabilityAdaptationCodebook, fetchCmrElevatorAccessCodebook, fetchCmrWaterSupplyConnectionCodebook, fetchCmrSewageConnectionCodebook, fetchCmrElectricityConnectionCodebook, fetchCmrGasConnectionCodebook, fetchCmrInternetConnectionCodebook, fetchCmrHeatingConnectionCodebook, fetchCmrHeatingEnergySourceCodebook, fetchCmrCoolingConnectionCodebook } from 'app/edozvola/codebooks/codebooks.service';
import {
  fetchAccessibilityAppliedMeasureCodebook,
  fetchAccessibilityRatingCodebook,
  fetchAdministrativeUnitCodebookForPublicCaseCategory,
  fetchAdministrativeUnitForAuthority,
  fetchAppealSolutionFirstDegreeCodebook,
  fetchAppealSolutionSecondDegreeCodebook,
  fetchApplicantsNumberCodebook,
  fetchAttachmentTypeCodebook,
  fetchAuthorityCodebook,
  fetchBuildingIndependentFunctionalNumberCodebook,
  fetchBuildingNumberCodebook,
  fetchBuildingPlacementCodebook,
  fetchBuildingPurposeCodebook,
  fetchBuildingPurposeCodebookByType,
  fetchBuildingTypeNationalClassificationCodebook,
  fetchBuildingTypeNationalClassificationCodebookForCBPType,
  fetchCadastralMunicipalities,
  fetchCaseCategoryForCase,
  fetchCaseCategoryForCaseGroup,
  fetchCaseCategoryForFilterCodebook,
  fetchCaseCategoryOptions,
  fetchCaseFunctionCodebook,
  fetchCaseGroupCodebook,
  fetchCasePublicAuthorityOptions,
  fetchCaseStatusForFilterCodebook,
  fetchChamberMemberCodebook,
  fetchChamberMemberCodebookForChamber,
  fetchChamberMemberCodebookForSiteSupervisor, fetchChambers,
  fetchCityMunicipalities,
  fetchCityMunicipalitiesAndCountiesForCase,
  fetchCityMunicipalitiesWithCounty,
  fetchCommunities,
  fetchCommunitiesWithCityMunicipalitiesAndCounty,
  fetchConnectionPowerGridCodebook,
  fetchConnectionSewageCodebook,
  fetchConnectionTrafficCodebook,
  fetchConstructionBuildingProcedureByTypeCodebook,
  fetchConstructionBuildingProcedureTypeCodebook,
  fetchConstructionCommencementCodebook,
  fetchConstructionFeeAmountOptions,
  fetchConstructionNumberCodebook,
  fetchCosolverForCase,
  fetchCountries,
  fetchCountyCodebook,
  fetchDeliveryMethodCodebook,
  fetchEnergyCertificateMarkCodebook,
  fetchEntryLetterDeliveryCodebook,
  fetchEstimatedConstructionCostOptions,
  fetchExistingBuildingRatioCodebook,
  fetchFormationCommitmentCodebook,
  fetchGreenInfrastructureTypeCodebook,
  fetchHouseNumbers,
  fetchJptActivityOptions,
  fetchLawsuitSolutionOptions,
  fetchLegalRemedyCodebook,
  fetchLitigationOptions,
  fetchMainProjectTypeCodebookForCaseCategory,
  fetchMethodOfApplicationOptions,
  fetchNoticeBoardDeliveryOptions,
  fetchNumberOfDaysToSolveCodebook,
  fetchPartyFeatureCodebook,
  fetchPartyFileInsightCodebook,
  fetchPartyNumberCodebook,
  fetchPhaseConstructionTypeOptionsCodebook,
  fetchProcedureNumberCodebook,
  fetchProcurationTypes,
  fetchProjectMapCodebook,
  fetchProjectTypeByVocationalDesignationCodebook,
  fetchProjectTypeByVocationalDesignationCodebookForCaseCategory,
  fetchProjectTypeCodebook,
  fetchProjectTypeCodebookForCaseCategory,
  fetchPublicAuthorityOptions,
  fetchReportTypeCodebook,
  fetchRequestAmendmentCodebook,
  fetchRequestAttachmentsForCaseCategory,
  fetchRequestWebIds,
  fetchRequirementGroupCodebook,
  fetchResolutionDeadlineCodebook,
  fetchResolutionTypeCodebook,
  fetchRevisionDeliveryOptions,
  fetchRevisionTypeOptions,
  fetchSolverForCase,
  fetchSpecialFeeOptions,
  fetchStatementTypeCodebook,
  fetchStreets,
  fetchSubjectTypeCodebook,
  fetchSubjectTypeForCaseSubmission,
  fetchTemplateCodebook,
  fetchUrbanPlanObligation,
  fetchWorkTypeCodebook,
  fetchZoningPlans,
  fetchZoningPlanTypes,
} from 'app/edozvola/codebooks/codebooks.service';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import { CodebookModel } from 'app/shared/model/shared.model';

export const fetchAttachmentTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'attachment-type'],
    queryFn: fetchAttachmentTypeCodebook,
  });
};

export const fetchProcurationTypesQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'procuration-types'],
    queryFn: fetchProcurationTypes,
  });
};

export const fetchCountriesQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'country'],
    queryFn: fetchCountries,
  });
};

export const fetchCountiesQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'county'],
    queryFn: fetchCountyCodebook,
  });
};

export const fetchCityMunicipalitiesQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'city-municipality'],
    queryFn: fetchCityMunicipalities,
  });
};

export const fetchCityMunicipalitiesWithCountyQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'city-municipality-county'],
    queryFn: fetchCityMunicipalitiesWithCounty,
  });
};

export const fetchCityMunicipalitiesAndCountiesForCaseQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['codebook', 'city-municipality-county-for-case', idCase],
    queryFn: ({ signal }) => fetchCityMunicipalitiesAndCountiesForCase(idCase),
  });
};

export const fetchZoningPlanTypesQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'zoning-plan-types'],
    queryFn: ({ signal }) => fetchZoningPlanTypes(),
  });
};

export const fetchCommunitiesQuery = (idCityMunicipality: number | string | undefined) => {
  return useQuery({
    queryKey: ['codebook', 'communities', idCityMunicipality],
    queryFn: () => fetchCommunities(idCityMunicipality),
    enabled: !!idCityMunicipality,
  });
};

export const fetchCommunitiesWithCityMunicipalitiesAndCountyQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'communities-with-cities-and-county'],
    queryFn: () => fetchCommunitiesWithCityMunicipalitiesAndCounty(),
  });
};

export const fetchStreetsQuery = (idCommunity: number | string | undefined) => {
  return useQuery({
    queryKey: ['codebook', 'streets', idCommunity],
    queryFn: () => fetchStreets(idCommunity),
    enabled: !!idCommunity,
  });
};

export const fetchHouseNumbersQuery = (idStreet: number | string | undefined) => {
  return useQuery({
    queryKey: ['codebook', 'house-numbers', idStreet],
    queryFn: () => fetchHouseNumbers(idStreet),
    enabled: !!idStreet,
  });
};

export const fetchResolutionTypeCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'resolution-type'],
    queryFn: fetchResolutionTypeCodebook,
  });
};

export const fetchResolutionDeadlineCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'resolution-deadline'],
    queryFn: fetchResolutionDeadlineCodebook,
  });
};

export const fetchAppealSolutionFirstDegreeCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'appeal-solution-first-degree'],
    queryFn: fetchAppealSolutionFirstDegreeCodebook,
  });
};

export const fetchAppealSolutionSecondDegreeCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'appeal-solution-second-degree'],
    queryFn: fetchAppealSolutionSecondDegreeCodebook,
  });
};

export const fetchFormationCommitmentCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'formation-commitment'],
    queryFn: fetchFormationCommitmentCodebook,
  });
};

export const fetchConnectionTrafficCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'connection-traffic'],
    queryFn: fetchConnectionTrafficCodebook,
  });
};

export const fetchConnectionPowerGridCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'connection-power-grid'],
    queryFn: fetchConnectionPowerGridCodebook,
  });
};

export const fetchConnectionSewageCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'connection-sewage'],
    queryFn: fetchConnectionSewageCodebook,
  });
};

export const fetchExistingBuildingRatioCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'existing-building-ratio'],
    queryFn: fetchExistingBuildingRatioCodebook,
  });
};

export const fetchApplicantsNumberCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'applicants-number'],
    queryFn: fetchApplicantsNumberCodebook,
  });
};

export const fetchPartyNumberCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'party-number'],
    queryFn: fetchPartyNumberCodebook,
  });
};

export const fetchPartyFileInsightCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'party-file-insight'],
    queryFn: fetchPartyFileInsightCodebook,
  });
};

export const fetchProjectTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'project-type'],
    queryFn: () => fetchProjectTypeCodebook(),
  });
};

export const fetchLegalRemedyCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'legal-remedy'],
    queryFn: fetchLegalRemedyCodebook,
  });
};

export const fetchProjectTypeQueryForCaseCategory = (idCase: string) => {
  return useQuery({
    queryKey: ['codebook', 'project-type-case-category', idCase],
    queryFn: ({ signal }) => fetchProjectTypeCodebookForCaseCategory(idCase),
  });
};

export const fetchProjectMapQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'project-map'],
    queryFn: () => fetchProjectMapCodebook(),
  });
};

export const fetchChambersQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'chambers'],
    queryFn: () => fetchChambers(),
  });
};

export const fetchChamberMembersQuery = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['codebook', 'chamber-members'],
    queryFn: () => fetchChamberMemberCodebook(),
    enabled: enabled
  });
};

export const fetchChamberMembersForChamberQuery = (idChamber: number) => {
  return useQuery({
    queryKey: ['codebook', 'chamber-members', 'chamber', idChamber],
    queryFn: () => fetchChamberMemberCodebookForChamber(idChamber),
    enabled: !!idChamber
  });
};

export const fetchSupervisorChamberMembersQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'chamber-members', 'site-supervisor'],
    queryFn: () => fetchChamberMemberCodebookForSiteSupervisor(),
  });
};

export const fetchCaseFunctionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'case-function'],
    queryFn: fetchCaseFunctionCodebook,
  });
};

export const fetchDeliveryMethodQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'delivery-method'],
    queryFn: fetchDeliveryMethodCodebook,
  });
};

export const fetchEntryLetterDeliveryQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'entry-letter-delivery'],
    queryFn: fetchEntryLetterDeliveryCodebook,
  });
};

export const fetchConstructionBuildingProcedureTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'construction-building-procedure-type'],
    queryFn: fetchConstructionBuildingProcedureTypeCodebook,
  });
};

export const fetchBuildingPurposeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'building-purpose'],
    queryFn: () => fetchBuildingPurposeCodebook(),
  });
};

export const fetchBuildingPurposeByTypeQuery = (type: number) => {
  return useQuery({
    queryKey: ['codebook', 'building-purpose', 'construction-building-procedure-type'],
    queryFn: () => fetchBuildingPurposeCodebookByType(type),
  });
};

export const fetchRequirementGroupQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'requirement-group'],
    queryFn: () => fetchRequirementGroupCodebook(),
  });
};

export const fetchBuildingPlacementQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'building-placement'],
    queryFn: () => fetchBuildingPlacementCodebook(),
  });
};

export const fetchBuildingIndependentFunctionalNumberQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'building-independent-functional-number'],
    queryFn: () => fetchBuildingIndependentFunctionalNumberCodebook(),
  });
};

export const fetchConstructionCommencementQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'construction-commencement'],
    queryFn: () => fetchConstructionCommencementCodebook(),
  });
};

export const fetchBuildingTypeNationalClassificationQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'building-type-national-classification'],
    queryFn: () => fetchBuildingTypeNationalClassificationCodebook(),
  });
};

export const fetchBuildingTypeNationalClassificationForCBPTypeQuery = (idConstructionBuildingProcedureType: number) => {
  return useQuery({
    queryKey: ['codebook', 'building-type-national-classification', 'construction-building-procedure-type'],
    queryFn: () => fetchBuildingTypeNationalClassificationCodebookForCBPType(idConstructionBuildingProcedureType),
  });
};

export const fetchAccessibilityRatingQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'accessibility-rating'],
    queryFn: () => fetchAccessibilityRatingCodebook(),
  });
};

export const fetchAccessibilityAppliedMeasureQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'accessibility-applied-measure'],
    queryFn: () => fetchAccessibilityAppliedMeasureCodebook(),
  });
};

export const fetchGreenInfrastructureTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'green-infrastructure-type'],
    queryFn: () => fetchGreenInfrastructureTypeCodebook(),
  });
};

export const fetchEnergyCertificateMarkQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'energy-certificate-mark'],
    queryFn: () => fetchEnergyCertificateMarkCodebook(),
  });
};

export const fetchConstructionBuildingProcedureByTypeCodebookQuery = (idCase: string, type: number) => {
  return useQuery({
    queryKey: ['codebook', 'construction-building-procedure-by-type'],
    queryFn: () => fetchConstructionBuildingProcedureByTypeCodebook(idCase, type),
  });
};

export const fetchBuildingNumberQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'building-number'],
    queryFn: () => fetchBuildingNumberCodebook(),
  });
};

export const fetchConstructionNumberQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'construction-number'],
    queryFn: () => fetchConstructionNumberCodebook(),
  });
};

export const fetchProcedureNumberQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'procedure-number'],
    queryFn: () => fetchProcedureNumberCodebook(),
  });
};

export const fetchPartyFeatureQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'party-feature'],
    queryFn: () => fetchPartyFeatureCodebook(),
  });
};

export const fetchMainProjectTypeQueryForCaseCategory = (idCase: string) => {
  return useQuery({
    queryKey: ['codebook', 'main-project-type-case-category', idCase],
    queryFn: ({ signal }) => fetchMainProjectTypeCodebookForCaseCategory(idCase),
  });
};

export const fetchProjectTypeByVocationalDesignationQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'project-type-by-vocational-designation'],
    queryFn: ({ signal }) => fetchProjectTypeByVocationalDesignationCodebook(),
  });
};

export const fetchProjectTypeByVocationalDesignationForCaseCategoryQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['codebook', 'project-type-by-vocational-designation'],
    queryFn: ({ signal }) => fetchProjectTypeByVocationalDesignationCodebookForCaseCategory(idCase),
  });
};

export const fetchRevisionTypeOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'revision-type-options'],
    queryFn: ({ signal }) => fetchRevisionTypeOptions(),
  });
};

export const fetchRevisionDeliveryOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'revision-delivery-options'],
    queryFn: ({ signal }) => fetchRevisionDeliveryOptions(),
  });
};

export const fetchReportTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'report-type'],
    queryFn: fetchReportTypeCodebook,
  });
};

export const fetchStatementTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'statement-type'],
    queryFn: fetchStatementTypeCodebook,
  });
};

export const fetchWorkTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'work-type'],
    queryFn: fetchWorkTypeCodebook,
  });
};

export const fetchConstructionFeeAmountQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'construction-fee-amount'],
    queryFn: ({ signal }) => fetchConstructionFeeAmountOptions(),
  });
};

export const fetchSpecialFeeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'special-fee'],
    queryFn: ({ signal }) => fetchSpecialFeeOptions(),
  });
};

export const fetchEstimatedConstructionCostQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'estimated-construction-cost'],
    queryFn: ({ signal }) => fetchEstimatedConstructionCostOptions(),
  });
};

export const fetchLawsuitSolutionOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'lawsuit-solution'],
    queryFn: ({ signal }) => fetchLawsuitSolutionOptions(),
  });
};

export const fetchNoticeBoardDeliveryOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'notice-board-delivery'],
    queryFn: ({ signal }) => fetchNoticeBoardDeliveryOptions(),
  });
};

export const fetchAuthorityCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'authority'],
    queryFn: ({ signal }) => fetchAuthorityCodebook()
  })
}

export const fetchPublicAuthorityOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'public-authority'],
    queryFn: ({ signal }) => fetchPublicAuthorityOptions(),
  });
};

export const fetchPhasedConstructionTypeOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'phased-construction-type'],
    queryFn: () => fetchPhaseConstructionTypeOptionsCodebook(),
  });
};

export const fetchCasePublicAuthorityOptionsQuery = (uuid: string) => {
  return useQuery({
    queryKey: ['codebook', 'case-public-authority', { caseUuid: uuid }],
    queryFn: ({ signal }) => fetchCasePublicAuthorityOptions(uuid),
  });
};

export const fetchJptActivityOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'jpt-activity-options'],
    queryFn: ({ signal }) => fetchJptActivityOptions(),
  });
};

export const fetchLitigationOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'litigation'],
    queryFn: ({ signal }) => fetchLitigationOptions(),
  });
};

export const fetchMethodOfApplicationOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'method-of-application'],
    queryFn: ({ signal }) => fetchMethodOfApplicationOptions(),
  });
};

export const fetchCadastralMunicipalitiesQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cadastral-municipality'],
    queryFn: fetchCadastralMunicipalities,
  });
};

export const fetchTemplateQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'act-type'],
    queryFn: fetchTemplateCodebook,
  });
};

export const fetchUrbanPlanOblgiationQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'urban-plan-obligation'],
    queryFn: fetchUrbanPlanObligation,
  });
};

export const fetchZoningPlansQuery = (pagination: PaginationState, payload: any) => {
  return useQuery({
    queryKey: ['zoning-plans', { payload: payload, pagination: { ...pagination } }],
    queryFn: ({ signal }) => fetchZoningPlans(pagination.page, pagination.size, pagination.column, pagination.direction, payload),
  });
};

export const fetchCaseCategoryForCaseQuery = (caseId: string) => {
  return useQuery({
    queryKey: ['codebook', 'case-category-for-case', { caseId: caseId }],
    queryFn: ({ signal }) => fetchCaseCategoryForCase(caseId)
  });
};

export const fetchCosolverForCaseQuery = (caseId: string) => {
  return useQuery({
    queryKey: ['codebook', 'cosolver-options-for-case', { caseId: caseId }],
    queryFn: ({ signal }) => fetchCosolverForCase(caseId),
  });
};

export const fetchSolverForCaseQuery = (caseId: string) => {
  return useQuery({
    queryKey: ['codebook', 'solver-options-for-case', { caseId: caseId }],
    queryFn: ({ signal }) => fetchSolverForCase(caseId),
  });
};

export const fetchCaseGroupCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'case-group-codebook-query'],
    queryFn: ({ signal }) => fetchCaseGroupCodebook(),
  });
};

export const fetchCaseCategoryCodebookForCaseGroupQuery = (
  selectedOption: any,
  isEdozvola = false,
  isEarhiva = false,
  isPublic = false
) => {
  return useQuery({
    queryKey: [
      'codebook',
      'case-category-for-case-group-query',
      { isEarhiva: isEarhiva, isEdozvola: isEdozvola, isPublic: isPublic },
    ],
    queryFn: ({ signal }) => fetchCaseCategoryForCaseGroup(selectedOption, isEdozvola, isEarhiva, isPublic),
    enabled: !!selectedOption
  });
};

export const fetchAdministrativeUnitCodebookForPublicCaseCategoryQuery = (
  selectedOption: any,
) => {
  return useQuery({
    queryKey: [
      'codebook',
      'administrative-unit-for-case-category-query',
    ],
    queryFn: ({ signal }) => fetchAdministrativeUnitCodebookForPublicCaseCategory(selectedOption),
  });
};

export const fetchRequestAttachmentsForCaseCategoryQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['codebook', 'request-attachments-case-category', idCase],
    queryFn: ({ signal }) => fetchRequestAttachmentsForCaseCategory(idCase),
  });
};

export const fetchRequestAmendmentCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'request-amendment'],
    queryFn: ({ signal }) => fetchRequestAmendmentCodebook(),
  });
};

export const fetchNumberOfDaysToSolveCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'number-of-days-to-solve'],
    queryFn: ({ signal }) => fetchNumberOfDaysToSolveCodebook(),
  });
};

export const fetchSubjectTypeQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'subject-type'],
    queryFn: fetchSubjectTypeCodebook,
  });
};

export const fetchSubjectTypeForCaseSubmissionQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'subject-type-for-case-submission'],
    queryFn: fetchSubjectTypeForCaseSubmission,
  });
};

export const fetchRequestWebIdsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'request-web-ids-query'],
    queryFn: ({ signal }) => fetchRequestWebIds(),
  });
};

export const fetchCaseCategoryOptionsQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'case-category-options'],
    queryFn: fetchCaseCategoryOptions,
  });
};

export const fetchCaseStatusForFilterQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'case-status-for-filter'],
    queryFn: () => fetchCaseStatusForFilterCodebook(),
  });
};

export const fetchCaseCategoryForFilterCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'case-category-for-filter'],
    queryFn: () => fetchCaseCategoryForFilterCodebook(),
  });
};

export const fetchAdministrativeUnitForAuthorityQuery = (authority: CodebookModel[]) => {
  return useQuery({
    queryKey: ['codebook', 'administrative-unit-for-authority', {authority: authority}],
    queryFn: () => fetchAdministrativeUnitForAuthority(authority),
    enabled: authority && authority.length > 0
  });
};


export const fetchCmrBuildingPartCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-building-part'],
    queryFn: ({ signal }) => fetchCmrBuildingPartCodebook(),
  });
};

export const fetchCmrSpecialBuildingPartCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-special-building-part'],
    queryFn: ({ signal }) => fetchCmrSpecialBuildingPartCodebook(),
  });
};

export const fetchCmrSpaceTypeCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-space-type'],
    queryFn: ({ signal }) => fetchCmrSpaceTypeCodebook(),
  });
};

export const fetchCmrFloorCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-floor'],
    queryFn: ({ signal }) => fetchCmrFloorCodebook(),
  });
};

export const fetchCmrFloorTypeCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-floor-type'],
    queryFn: ({ signal }) => fetchCmrFloorTypeCodebook(),
  });
};

export const fetchCmrRoomCountCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-room-count'],
    queryFn: ({ signal }) => fetchCmrRoomCountCodebook(),
  });
};

export const fetchCmrLivingRoomCountCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-living-room-count'],
    queryFn: ({ signal }) => fetchCmrLivingRoomCountCodebook(),
  });
};

export const fetchCmrKitchenCountCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-kitchen-count'],
    queryFn: ({ signal }) => fetchCmrKitchenCountCodebook(),
  });
};

export const fetchCmrBathroomCountCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-bathroom-count'],
    queryFn: ({ signal }) => fetchCmrBathroomCountCodebook(),
  });
};

export const fetchCmrSeparateToiletCountCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-separate-toilet-count'],
    queryFn: ({ signal }) => fetchCmrSeparateToiletCountCodebook(),
  });
};

export const fetchCmrDisabilityAdaptationCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-disability-adaptation'],
    queryFn: ({ signal }) => fetchCmrDisabilityAdaptationCodebook(),
  });
};

export const fetchCmrElevatorAccessCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-elevator-access'],
    queryFn: ({ signal }) => fetchCmrElevatorAccessCodebook(),
  });
};

export const fetchCmrWaterSupplyConnectionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-water-supply-connection'],
    queryFn: ({ signal }) => fetchCmrWaterSupplyConnectionCodebook(),
  });
};

export const fetchCmrSewageConnectionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-sewage-connection'],
    queryFn: ({ signal }) => fetchCmrSewageConnectionCodebook(),
  });
};

export const fetchCmrElectricityConnectionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-electricity-connection'],
    queryFn: ({ signal }) => fetchCmrElectricityConnectionCodebook(),
  });
};

export const fetchCmrGasConnectionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-gas-connection'],
    queryFn: ({ signal }) => fetchCmrGasConnectionCodebook(),
  });
};

export const fetchCmrInternetConnectionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-internet-connection'],
    queryFn: ({ signal }) => fetchCmrInternetConnectionCodebook(),
  });
};

export const fetchCmrHeatingConnectionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-heating-connection'],
    queryFn: ({ signal }) => fetchCmrHeatingConnectionCodebook(),
  });
};

export const fetchCmrHeatingEnergySourceCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-heating-energy-source'],
    queryFn: ({ signal }) => fetchCmrHeatingEnergySourceCodebook(),
  });
};

export const fetchCmrCoolingConnectionCodebookQuery = () => {
  return useQuery({
    queryKey: ['codebook', 'cmr-cooling-connection'],
    queryFn: ({ signal }) => fetchCmrCoolingConnectionCodebook(),
  });
};
